import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BoothChapterView } from './BoothChapterView';
import { BoothHome } from './BoothHome';
import { BoothSummary } from './BoothSummary';
import { BoothTopBar } from './BoothTopBar';
import { boothChapters } from '../../data/booth';
import type { BoothMode } from '../../types/booth';
type View = {
  kind: 'home';
} | {
  kind: 'chapter';
  id: string;
} | {
  kind: 'summary';
};
interface BoothExperienceProps {
  /** Auto-plays between the first two screens (used for campaign previews). */
  previewLoop?: boolean;
}
export function BoothExperience({
  previewLoop = false
}: BoothExperienceProps) {
  const [mode, setMode] = useState<BoothMode>('rep');
  const [view, setView] = useState<View>({
    kind: 'home'
  });
  const [visited, setVisited] = useState<string[]>([]);
  useEffect(() => {
    if (!previewLoop) return;
    const t = window.setTimeout(() => setView(view.kind === 'home' ? {
      kind: 'chapter',
      id: boothChapters[0].id
    } : {
      kind: 'home'
    }), 3400);
    return () => window.clearTimeout(t);
  }, [previewLoop, view]);
  const open = (id: string) => {
    setVisited(prev => prev.includes(id) ? prev : [...prev, id]);
    setView({
      kind: 'chapter',
      id
    });
  };
  const home = () => setView({
    kind: 'home'
  });
  const restart = () => {
    setVisited([]);
    setView({
      kind: 'home'
    });
  };
  const chapter = view.kind === 'chapter' ? boothChapters.find(c => c.id === view.id) : undefined;
  const viewKey = view.kind === 'chapter' ? view.id : view.kind;
  return <div className="flex h-full w-full flex-col bg-mist-50 text-navy-900" data-id="element-67" data-mp="273qeyp5fs7dg">
      <BoothTopBar mode={mode} onModeChange={setMode} onHome={view.kind === 'home' ? undefined : home} data-id="element-68" data-mp="271nmzzkq4463" />
      <div className="relative min-h-0 flex-1" data-id="element-69" data-mp="cpz5bpn3xni0">
        <AnimatePresence mode="wait" initial={false} data-id="element-70" data-mp="cqqqe6j2w2u1">
          <motion.div key={viewKey} initial={{
          opacity: 0,
          scale: 0.99
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.99
        }} transition={{
          duration: 0.35,
          ease: [0.22, 1, 0.36, 1]
        }} className="absolute inset-0" data-id="element-71" data-mp="8odnrqzmol1h">
            {view.kind === 'home' && <BoothHome mode={mode} visited={visited} onOpen={open} onFinish={() => setView({
            kind: 'summary'
          })} data-id="element-72" data-mp="2hpqhmktk16zz" />}
            {chapter && <BoothChapterView chapter={chapter} mode={mode} visited={visited} onOpen={open} onHome={home} data-id="element-73" data-mp="2qsja2reh3ore" />}
            {view.kind === 'summary' && <BoothSummary visited={visited} onRestart={restart} onBack={home} data-id="element-74" data-mp="2vp9prdmd8ica" />}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}